"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcFormFieldLabel_1 = require("./AcFormFieldLabel");
var AcTimestamp_1 = require("../display/AcTimestamp");
var AcFormField_module_scss_1 = __importDefault(require("./AcFormField.module.scss"));
exports.AcFormField = function (_a) {
    var fieldName = _a.fieldName, label = _a.label, type = _a.type, inline = _a.inline, placeholder = _a.placeholder, plaintext = _a.plaintext, readOnly = _a.readOnly, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, onEnter = _a.onEnter, onClick = _a.onClick, invalid = _a.invalid, rows = _a.rows, required = _a.required, errorId = _a.errorId, appendIcon = _a.appendIcon, _b = _a.options, options = _b === void 0 ? [] : _b, children = _a.children, className = _a.className, inputWidth = _a.inputWidth;
    var onFormControlChange = function (e) {
        if (onChange) {
            onChange(fieldName, e.target.value);
        }
    };
    var onFormControlBlur = function (e) {
        if (onBlur) {
            onBlur(fieldName, e.target.value);
        }
    };
    var onFormControlFocus = function (e) {
        if (onFocus) {
            onFocus(fieldName, e.target.value);
        }
    };
    var onFormControlEnter = function (e) {
        if (onEnter) {
            if (e.keyCode === 13) {
                onEnter(fieldName, value);
            }
        }
    };
    var onChangeCheck = function (e) {
        var checked = e.target.checked;
        var inputValue = e.target.value;
        if (!Array.isArray(value))
            throw new Error('value is not array');
        var updatedValue = value.slice();
        if (checked) {
            if (!value.includes(inputValue)) {
                updatedValue.push(inputValue);
            }
        }
        else if (value.includes(inputValue)) {
            updatedValue = value.filter(function (v) { return v !== inputValue; });
        }
        if (onChange) {
            onChange(fieldName, updatedValue);
        }
    };
    var onFormClick = function (e) {
        if (onClick) {
            onClick(fieldName, value);
        }
    };
    var renderField = function () {
        var valueD = value;
        var formControl = (react_1.default.createElement(react_bootstrap_1.Form.Control, { style: { width: inputWidth ? inputWidth + "px" : undefined }, onChange: onFormControlChange, onBlur: onFormControlBlur, onFocus: onFormControlFocus, placeholder: placeholder, plaintext: plaintext, readOnly: readOnly, value: (valueD !== null && valueD !== void 0 ? valueD : ''), rows: rows, onClick: onFormClick, as: type === 'textarea' ? 'textarea' : undefined, type: type === 'number' ? 'number' : undefined }));
        if (type === 'search') {
            var adornment = (react_1.default.createElement("i", { className: "far fa-search fa-2x", style: {
                    position: 'absolute',
                    left: '2.5rem',
                    top: '1rem',
                    zIndex: 100,
                    color: '#b6cde2',
                    pointerEvents: 'none',
                } }));
            var clearButton = (react_1.default.createElement("i", { className: "far fa-times text-secondary fa-fw fs-18", onClick: function () {
                    onEnter === null || onEnter === void 0 ? void 0 : onEnter(undefined, '');
                    onChange === null || onChange === void 0 ? void 0 : onChange(undefined, '');
                }, style: {
                    cursor: 'pointer',
                    position: 'absolute',
                    zIndex: 100,
                    right: '1.5rem',
                    top: '0rem',
                    padding: '1.3rem 2.4rem 1.2rem 1.2rem',
                } }));
            return (react_1.default.createElement(react_1.default.Fragment, null,
                adornment,
                react_1.default.createElement(react_bootstrap_1.Form.Control, { onChange: onFormControlChange, onKeyUp: onFormControlEnter, placeholder: placeholder, className: "pl-9 no-x " + AcFormField_module_scss_1.default.no_x, value: value }),
                clearButton));
        }
        if (type === 'date') {
            valueD = AcTimestamp_1.renderDate(value);
        }
        if (plaintext) {
            return react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "py-2 fs-14 " + AcFormField_module_scss_1.default.break_word }, valueD);
        }
        if (appendIcon != null) {
            return (react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                formControl,
                react_1.default.createElement(react_bootstrap_1.InputGroup.Append, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { onClick: onFormClick }, appendIcon))));
        }
        if (type === 'checkbox' || type === 'radio') {
            return (react_1.default.createElement("div", { key: inline ? "inline-" + type : "custom-single-" + type }, options.map(function (option, index) { return (react_1.default.createElement(react_bootstrap_1.Form.Check, { id: "form-" + type + "-" + option.value + "-" + label, custom: true, disabled: option.disabled ? option.disabled : false, type: type, name: fieldName, inline: inline, label: option.label, key: option.label, value: option.value, checked: Array.isArray(value) && value.includes(option.value), onChange: onChangeCheck })); })));
        }
        if (type === 'select') {
            return (react_1.default.createElement(react_bootstrap_1.Form.Control, { custom: true, onChange: onFormControlChange, readOnly: readOnly, value: (valueD !== null && valueD !== void 0 ? valueD : ''), as: "select" },
                placeholder && react_1.default.createElement("option", { value: "" }, placeholder),
                options.map(function (option, index) { return (react_1.default.createElement("option", { id: "form-" + type + "-" + option.value, disabled: option.disabled ? option.disabled : false, label: option.label, key: option.value, value: option.value })); })));
        }
        if (type === 'switch') {
            return (react_1.default.createElement(react_1.default.Fragment, null, options.map(function (option, index) { return (react_1.default.createElement("div", { className: "d-flex flex-row align-items-center mt-1", key: index, onClick: function () {
                    if (onChange) {
                        onChange(fieldName, value === option.value ? option.offValue : option.value);
                    }
                } },
                option.offLabel && react_1.default.createElement("span", { className: "pr-1" }, option.offLabel),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", custom: true, label: option.label, readOnly // since state is managed by parent
                    : true, checked: value === option.value }))); })));
        }
        return formControl;
    };
    return (
    // fix for IE to set width correctly
    react_1.default.createElement("div", { style: { flex: '1 1 100%' } },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: className },
            react_1.default.createElement(AcFormFieldLabel_1.AcFormFieldLabel, { label: label, readOnly: readOnly, required: required }),
            renderField(),
            children,
            invalid && errorId && !readOnly && (react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid", style: { display: 'block' } }, errorId)))));
};
exports.AcFormField.displayName = 'AcFormField';
//# sourceMappingURL=AcFormField.js.map